import { SortSchema } from '@types'

export function depthVisualOrderSorter(a: SortSchema, b: SortSchema) {
  const [parent, children, visualOrder] = a.split('!').flatMap((el) => el.split('-'))
  const [parentb, childrenb, visualOrderb] = b.split('!').flatMap((el) => el.split('-'))
  if (parent !== parentb) {
    return parseInt(parent) - parseInt(parentb)
  }
  if (children !== childrenb) {
    return parseInt(children) - parseInt(childrenb)
  }

  return parseInt(visualOrder) - parseInt(visualOrderb)
}
